<template>
    <div class="introductionBox">
       <businessBanner tabIndex="4"></businessBanner>
       <div :class="isMobile?'mobileShow':'mainShow'">
        <p class="font20 fontw">造价咨询</p>
        <p class="mt36 jies">瑞和安惠拥有原工程造价咨询甲级资质，是河北省重点扶持的工程造价咨询企业，曾多次荣获国家、省、市级优秀成果奖，被中价协评为AAA级信用企业。业务区域覆盖河北省全域及雄安新区，省外业务区域持续扩展，已在十余个省份设立服务网点。客户类型涵盖政府部门、央国企及上市公司。项目类型涵盖了大型商业综合体、商业住宅、公共建筑、工业建筑、石油化工、市政工程、园林绿化、交通、电力、水利等，常年位居石家庄造价咨询机构收入排名前列。</p>
        <p class="mt20 jies">在数智化赋能下，瑞和安惠造价业务正在从传统计量计价服务向全生命周期成本管控与全过程造价咨询模式全面升级。面向未来，造价业务将作为集团全咨体系的数据中枢，持续将指标、清单、材价整合为核心数据资产，打造数据驱动的全过程成本管控智能平台，构建"咨询+平台+数据"的立体服务模式，成为客户信赖的工程项目投资管控核心顾问。</p>
       </div>
       <!-- 服务范围 -->
       <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'sec-inner'">
                <div :class="isMobile?'contTM':'sec-title'">服务范围</div>
                <div class="svc-layout">
                    <div class="svc-left">
                        <p class="svc-sub"><b>咨询产品</b></p>
                        <div class="svc-grid">
                            <div class="svc-item">
                                <span class="svc-label">决策阶段：</span>
                                <span class="svc-val">估算编制；估算审核；概算编制；概算审核</span>
                            </div>
                            <div class="svc-item">
                                <span class="svc-label">招投标阶段：</span>
                                <span class="svc-val">询价；清单编制；清单审核；限价编制；限价审核</span>
                            </div>
                            <div class="svc-item">
                                <span class="svc-label">施工阶段：</span>
                                <span class="svc-val">预算编制；预算审核；施工阶段造价咨询</span>
                            </div>
                            <div class="svc-item">
                                <span class="svc-label">竣工阶段：</span>
                                <span class="svc-val">结算编制；结算审核；决算编制；决算审核</span>
                            </div>
                            <div class="svc-item">
                                <span class="svc-label">造价鉴定：</span>
                                <span class="svc-val">仲裁鉴定；司法鉴定</span>
                            </div>
                        </div>
                        <p class="svc-sub"><b>数智化产品</b></p>
                        <p class="svc-val">SaaS产品(3)、数据产品(7)、模型产品(6)、数字孪生产品(1)</p>
                    </div>
                    <div class="svc-right">
                        <img class="svc-img" src="@/assets/businessScope/zaoj.png" alt="">
                    </div>
                </div>
            </div>
       </div>
       <!-- 荣誉奖项 -->
       <div :class="isMobile?'mobileMWrap':'mainWrap'">
            <div :class="isMobile?'mainM':'sec-inner'">
                <div :class="isMobile?'contTM':'sec-title'">荣誉奖项</div>
                <div class="honor-layout">
                    <div class="honor-left">
                        <img class="honor-img" src="@/assets/businessScope/yej.png" alt="">
                    </div>
                    <ul class="honor-list">
                        <li>中国建设工程造价管理协会会员单位</li>
                        <li>河北省建设工程造价管理协会副会长</li>
                        <li>中国建设工程造价管理协会AAA级信用企业</li>
                        <li>河北省优秀造价成果一等奖</li>
                        <li>河北省优秀工程造价成果奖</li>
                    </ul>
                </div>
            </div>
       </div>
       <!-- 典型业绩展示 -->
       <TypicalAchievement category-id="100137" :show-tabs="false" />
    </div>
</template>

<script>
import businessBanner from '@/components/businessBanner'
import TypicalAchievement from '@/components/TypicalAchievement.vue'
export default {
    name: 'CostConsultation',
    components: { businessBanner, TypicalAchievement },
    data() {
        return {}
    },
    mounted() {}
}
</script>

<style scoped>
.introductionBox {
    padding-bottom: 50px;
}
.mainShows {
    width: 100%;
    background-color: #F7F9FD;
    margin-top: 42px;
}
.mainWrap {
    width: 100%;
    margin-top: 42px;
}
.mobileMWrap {
    width: 100%;
    margin-top: 20px;
}
.mobileShows {
    width: 100%;
    background-color: #F7F9FD;
    margin-top: 20px;
}
.sec-inner {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0 60px;
}
.mainM {
    width: 100%;
    margin: 0 auto;
    padding: 10px;
}
.jies {
    line-height: 32px;
    text-indent: 2em;
    color: #444;
    font-size: 15px;
}
.contM {
    width: 100%;
    color: #666;
    line-height: 30px;
}
.contTM {
    color: #247CD6;
    font-size: 22px;
    margin-top: 20px;
    margin-bottom: 16px;
    font-weight: bold;
}
.contImgShow {
    max-width: 100%;
    margin-top: 20px;
    margin-bottom: 10px;
    border-radius: 6px;
}
/* 板块标题 */
.sec-title {
    color: #247CD6;
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 32px;
    padding-left: 14px;
    border-left: 4px solid #247CD6;
    line-height: 1;
}
/* 服务范围布局 */
.svc-layout {
    display: flex;
    align-items: flex-start;
    gap: 40px;
}
.svc-left {
    width: 400px;
    flex-shrink: 0;
}
.svc-right {
    flex: 1;
    min-width: 0;
}
.svc-img {
    width: 100%;
    border-radius: 8px;
}
.svc-sub {
    font-size: 15px;
    color: #333;
    margin: 18px 0 12px;
}
.svc-grid {
    margin-bottom: 8px;
}
.svc-item {
    line-height: 34px;
    font-size: 14px;
    color: #555;
    margin-bottom: 2px;
}
.svc-label {
    font-weight: bold;
    color: #333;
}
.svc-val {
    font-size: 14px;
    color: #555;
}
/* 荣誉奖项布局 */
.honor-layout {
    display: flex;
    align-items: flex-start;
    gap: 40px;
}
.honor-left {
    flex: 1;
    min-width: 0;
}
.honor-img {
    width: 80%;
    border-radius: 8px;
}
.honor-list {
    list-style: none;
    padding-left: 0;
    margin: 0;
    width: 440px;
    flex-shrink: 0;
}
.honor-list li {
    line-height: 55px;
    padding-left: 18px;
    position: relative;
    font-size: 15px;
    color: #555;
}
.honor-list li::before {
    content: "";
    width: 5px;
    height: 5px;
    background-color: #247CD6;
    border-radius: 50%;
    position: absolute;
    left: 2px;
    top: 18px;
}
</style>
